import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_deduct_trade_union_dues_from_wages_in_line_w_legal'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_deduct_trade_union_dues_from_wages_in_line_w_legal',
  name: 'Does the facility deduct trade union dues from wages in line with legal requirements?',
  description:
    'Union presence in the facility includes the existence of a company union and/or the affiliation of workers from the company to higher level unions (such as sectoral unions).\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements. \r\r\n\r\r\nLegal requirements may specify the form of consent required, and the duties imposed on the employer to deduct union dues from workers and transfer them to the union(s).\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, select the answer: Not applicable. No union presence in the facility during assessment period.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'union-na-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'union-na-nalr',
    },
    {
      name: 'Not applicable. No union presence in the facility during assessment period.',
      key: 'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
      slcpIndex: 3,
      slcpOptionName: 'union-na-nalr',
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 4,
      slcpOptionName: 'union-na-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: [
          'YES',
          'NO',
          'NOT_APPLICABLE_NO_UNION_PRESENCE_IN_THE_FAC_DURING_ASSESSMENT',
          'NO_APPLICABLE_LEGAL_REQS',
        ],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'foa-cb-3--1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12120,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
